module.exports = __webpack_public_path__ + "prod/20260124143402/img/officialAccount.85b10ff1.jpg";